export class TextHelper {
  static expandScientific(str: string) {
    if (!str.toLowerCase().includes('e')) return str

    const num = Number(str)
    return num.toLocaleString('en-US', {
      useGrouping: false,
      maximumFractionDigits: 20,
    })
  }

  static formatAmount(amountStr: any) {
    let str = String(amountStr)

    str = this.expandScientific(str)

    const num = Number(str)

    if (isNaN(num) || (str.includes('.') && Number(str) < 1)) {
      return str
    }

    if (num >= 1_000_000_000)
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
    if (num >= 1_000_000)
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
    if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'k'

    return str
  }

  static toFullNumber(value: string, decimals: number): string {
    if (!value) return ''

    if (!/[eE]/.test(value)) {
      return value
    }

    const num = Number(value)
    if (isNaN(num)) return ''

    const fixed = num.toFixed(decimals)

    return fixed.replace(/\.?0+$/, '')
  }

  static normalizeHash(hash: string): string {
    return typeof hash === 'string' ? hash.trim().toLowerCase() : hash
  }
}
